import { render, staticRenderFns } from "./basicConfig.vue?vue&type=template&id=5c9d8017&scoped=true&"
import script from "./basicConfig.vue?vue&type=script&lang=js&"
export * from "./basicConfig.vue?vue&type=script&lang=js&"
import style0 from "./basicConfig.vue?vue&type=style&index=0&id=5c9d8017&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d8017",
  null
  
)

export default component.exports